/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  SubOrderLite,
  SubOrderLiteFromJSON,
  SubOrderLiteFromJSONTyped,
  SubOrderLiteToJSON,
} from "./";

/**
 *
 * @export
 * @interface ProposalRequestLite
 */
export interface ProposalRequestLite {
  /**
   *
   * @type {string}
   * @memberof ProposalRequestLite
   */
  userEmail: string;
  /**
   *
   * @type {string}
   * @memberof ProposalRequestLite
   */
  userFullName: string;
  /**
   *
   * @type {string}
   * @memberof ProposalRequestLite
   */
  userCompany: string;
  /**
   *
   * @type {string}
   * @memberof ProposalRequestLite
   */
  medium: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ProposalRequestLite
   */
  forecastConversionGroups: Array<string>;
  /**
   *
   * @type {Array<SubOrderLite>}
   * @memberof ProposalRequestLite
   */
  subOrders: Array<SubOrderLite>;
  /**
   *
   * @type {boolean}
   * @memberof ProposalRequestLite
   */
  starterDocumentRequest: boolean;
  /**
   *
   * @type {string}
   * @memberof ProposalRequestLite
   */
  referer: string;
}

export function ProposalRequestLiteFromJSON(json: any): ProposalRequestLite {
  return ProposalRequestLiteFromJSONTyped(json, false);
}

export function ProposalRequestLiteFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ProposalRequestLite {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    userEmail: json["userEmail"],
    userFullName: json["userFullName"],
    userCompany: json["userCompany"],
    medium: json["medium"],
    forecastConversionGroups: json["forecastConversionGroups"],
    subOrders: (json["subOrders"] as Array<any>).map(SubOrderLiteFromJSON),
    starterDocumentRequest: json["starterDocumentRequest"],
    referer: json["referer"],
  };
}

export function ProposalRequestLiteToJSON(
  value?: ProposalRequestLite | null,
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    userEmail: value.userEmail,
    userFullName: value.userFullName,
    userCompany: value.userCompany,
    medium: value.medium,
    forecastConversionGroups: value.forecastConversionGroups,
    subOrders: (value.subOrders as Array<any>).map(SubOrderLiteToJSON),
    starterDocumentRequest: value.starterDocumentRequest,
    referer: value.referer,
  };
}
